class SliderTab {
  constructor(element = undefined, option = undefined) {
    if (element !== undefined) {
      this.init(element, option)
    }
  }

  init(element = null, option = undefined) {
    this.option = option
    this.element = element
    this.slider = document.createElement('div')
    this.sliderThumb = 'nav-slider-thumb'
    this.elemClass = 'nav-slider'
    const firstChild = this.element.querySelector('.nav-item:first-child .nav-link')
    const tab = firstChild.cloneNode()
    tab.innerHTML = ''
    this.slider.classList.add(this.sliderThumb, 'position-absolute', 'nav-link')
    this.element.classList.add(this.elemClass)
    this.slider.appendChild(tab)
    this.element.appendChild(this.slider)
    this.resetSlider()
    this.mouseClick()
    this.resize()
    this.updateRTL()
  }

  resetSlider() {
    const firstItem = this.element.querySelector('.nav-item:nth-child(1)')
    if (!firstItem) return
    window.requestAnimationFrame(() => {
      this.slider.style.padding = '0px'
      this.slider.style.width = firstItem.offsetWidth + 'px'
      this.slider.style.height = firstItem.offsetHeight + 'px'
      this.slider.style.transform = 'translate3d(0px, 0px, 0px)'
      this.slider.style.transition = '300ms ease-in-out'
    })
  }

  mouseClick() {
    this.element.onclick = (event) => {
      const target = this.getEventTarget(event)
      const item = target.closest('.nav-item')
      const items = Array.from(this.element.children)
      const index = items.indexOf(item) + 1
      if (item !== null) {
        this.updateSlide(item, items, index)
      }
    }
  }

  updateSlide(item, items, index, cb = undefined) {
    this.slider = this.element.querySelector(`.${this.sliderThumb}`)
    if (!this.slider || !item) return
    const prevItem = this.element.querySelectorAll('.nav-item')
    let elem
    Array.from(prevItem, (elem) => {
      const link = elem.querySelector('.nav-link')
      if (link) link.classList.remove('active')
    })
    window.requestAnimationFrame(() => {
      let sum = 0
      if (this.element.classList.contains('flex-column')) {
        let j = 1
        for (j; j <= items.indexOf(item); j++) {
          const li = this.element.querySelector('li:nth-child(' + j + ')')
          if (li) sum += li.offsetHeight
        }
        this.slider.style.transform = 'translate3d(0px,' + sum + 'px, 0px)'
        elem = this.element.querySelector('.nav-item:nth-child(' + j + ')')
        if (elem) {
          const l = elem.querySelector('.nav-link')
          if (l) l.classList.add('active')
          this.slider.style.height = elem.offsetHeight + 'px'
        }
        this.slider.style.width = '100%'
      } else {
        let j = 1
        for (j; j <= items.indexOf(item); j++) {
          const ni = this.element.querySelector('.nav-item:nth-child(' + j + ')')
          if (ni) sum += ni.offsetWidth
        }
        if (document.querySelector('html') && document.querySelector('html').getAttribute('dir') === 'rtl') {
          this.slider.style.transform = 'translate3d(-' + sum + 'px, 0px, 0px)'
        } else {
          this.slider.style.transform = 'translate3d(' + sum + 'px, 0px, 0px)'
        }
        elem = this.element.querySelector('.nav-item:nth-child(' + index + ')')
        if (elem) {
          const l = elem.querySelector('.nav-link')
          if (l) l.classList.add('active')
          this.slider.style.width = elem.offsetWidth + 'px'
        }
      }
      if (cb !== null && cb !== undefined && typeof cb === 'function') {
        cb(elem)
      }
    })
  }

  getEventTarget(event) {
    event = event || window.event
    return event.target || event.srcElement
  }

  destroy() {
    this.element.removeEventListener('mousemove', this.mouseOver)
    this.element.querySelector(`.${this.sliderThumb}`).remove()
    this.element.classList.remove(this.elemClass)
  }

  resize() {
    window.addEventListener('resize', () => {
      const target = this.element.querySelector('.active')
      const item = target.closest('.nav-item')
      const items = Array.from(this.element.children)
      const index = items.indexOf(item) + 1
      this.updateSlide(item, items, index)
    })
  }

  updateRTL() {
    // mutation observer for rtl
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          if (mutation.attributeName === 'dir') {
            const target = this.element.querySelector('.active')
            const item = target.closest('.nav-item')
            const items = Array.from(this.element.children)
            const index = items.indexOf(item) + 1
            this.updateSlide(item, items, index)
          }
        }
      })
    })
    observer.observe(document.querySelector('html'), {
      attributes: true
    })
  }
}

window.SliderTab = new SliderTab()
module.exports = SliderTab
